import styled from 'styled-components'
import { FormControl } from 'react-bootstrap'

export default styled(FormControl)`
    height: 40px;
`
